import classNames from 'classnames';
import s from './Section.module.scss';
import { ReactNode } from 'react';

interface SectionProps {
  className?: string;
  children: ReactNode;
  title: string;
}

export const Section = (props: SectionProps) => {
  const { className, children, title } = props;
  return (
    <div className={classNames(s.Section, {}, [className])}>
      <h2 className={s.title}>{title}</h2>
      {children}
    </div>
  );
};
